if (!customElements.get('floating-add-to-cart')) {
  customElements.define(
    'floating-add-to-cart',
    class FloatingAddToCart extends HTMLElement {
      constructor() {
        super();

        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.onMobileChange = this.onMobileChange.bind(this);
        this.onIntersection = this.onIntersection.bind(this);
        this.onFloatingClick = this.onFloatingClick.bind(this);
        this.syncFromMainButton = this.syncFromMainButton.bind(this);
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.floatingButton = this.querySelector('.floating-add-to-cart__button');
        this.floatingLabel = this.querySelector('.product-form__submit-label');

        if (!this.mainButton || !this.floatingButton) {
          this.hidden = true;
          return;
        }

        this.intersectionObserver = new IntersectionObserver(this.onIntersection, {
          root: null,
          threshold: 0,
        });
        this.intersectionObserver.observe(this.mainButton);

        this.mainButtonObserver = new MutationObserver(this.syncFromMainButton);
        this.mainButtonObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          subtree: true,
          characterData: true,
          childList: true,
        });

        this.floatingButton.addEventListener('click', this.onFloatingClick);
        this.mobileQuery.addEventListener('change', this.onMobileChange);

        this.mainButtonVisible = false;
        this.syncFromMainButton();
        this.onMobileChange();
      }

      disconnectedCallback() {
        this.intersectionObserver?.disconnect();
        this.mainButtonObserver?.disconnect();
        this.floatingButton?.removeEventListener('click', this.onFloatingClick);
        this.mobileQuery.removeEventListener('change', this.onMobileChange);
      }

      onIntersection(entries) {
        this.mainButtonVisible = entries.some((entry) => entry.isIntersecting);
        this.updateVisibility();
      }

      onMobileChange() {
        if (!this.mobileQuery.matches) {
          this.classList.remove('is-visible');
          return;
        }
        this.updateVisibility();
      }

      updateVisibility() {
        if (!this.mobileQuery.matches) return;

        const shouldShow = !this.mainButtonVisible;
        this.classList.toggle('is-visible', shouldShow);
        this.hidden = false;
      }

      onFloatingClick() {
        if (
          this.mainButton.disabled ||
          this.mainButton.getAttribute('aria-disabled') === 'true' ||
          this.mainButton.classList.contains('loading')
        ) {
          return;
        }

        this.mainButton.click();
      }

      syncFromMainButton() {
        const mainLabel = this.mainButton.querySelector('.product-form__submit-label');
        if (mainLabel && this.floatingLabel) {
          this.floatingLabel.textContent = mainLabel.textContent;
        }

        const isDisabled = this.mainButton.disabled;
        this.floatingButton.disabled = isDisabled;
        this.floatingButton.classList.toggle(
          'loading',
          this.mainButton.classList.contains('loading')
        );
        this.floatingButton.setAttribute(
          'aria-busy',
          this.mainButton.getAttribute('aria-busy') === 'true'
        );
      }
    }
  );
}
